class FrontError extends Error {
  fromComponent: string;
  date: Date;
  details: Record<string, unknown>;
  constructor(fromComponent = 'Error Component', details = null, ...params) {
    super(...params);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FrontError);
    }
    this.name = 'FrontError';
    this.fromComponent = fromComponent;
    this.message = fromComponent;
    this.details = details;
    this.date = new Date();
  }
}

export default FrontError;
